export default __webpack_public_path__ + "static/media/businesseggward1.51462108.png";